import React from 'react'
import { Box, Divider, List, ListItem, Typography } from '@mui/material'
import AccordionCashOutAccounts from './AccordionCashOutAccounts'
import AccordionCashOuts from './AccordionCashOuts'
import AccordionCharityDisbursementOption from './AccordionCharityDisbursementOption'
import AccordionExchangeInstructions from './AccordionExchangeInstructions'
import WalletsComponent from './WalletsComponent'
import { type AssetHolderIdProps } from '../../pages/DashboardHome'
import ActivityStatementComponent from './ActivityStatementComponent'
import LoadingComponent from '../../../shared/components/ui-widgets/LoadingComponent'
import ErrorComponent from '../../../shared/components/ui-widgets/ErrorComponent'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import { useGetWalletsQuery } from '../../../../api/asset-holders/financeApi'
import { getAssetHolderQuery } from '../../../../api/asset-holders/assetHolderApi'

const FinanceTabComponent: React.FC<AssetHolderIdProps> = ({ assetHolderId }: AssetHolderIdProps) => {
  const getAssetHolderApiResult = getAssetHolderQuery()
  const getWalletsApiResult = useGetWalletsQuery(assetHolderId)

  const verticalSpacing = 5
  const maxCardWidth = 600

  return (
    <>
      {/* <Typography variant={'h3'}>Finance</Typography> */}
      {/* <Divider sx={{ my: 3 }}/> */}

      {getAssetHolderApiResult.isLoading && <LoadingComponent/>}
      {getAssetHolderApiResult.isError &&
        <ErrorComponent message={RtkQueryHelper.mapResponseError(getAssetHolderApiResult.error)}/>}
      {getAssetHolderApiResult.isSuccess &&
        <>
          {getWalletsApiResult.isLoading && <LoadingComponent/>}
          {getWalletsApiResult.isError &&
            <ErrorComponent message={RtkQueryHelper.mapResponseError(getWalletsApiResult.error)}/>}

          <Box display={'flex'} sx={{ mb: verticalSpacing }}>
            <Box>
              <Typography variant={'h3'} sx={{ mb: 1 }}>Wallets</Typography>
              {getWalletsApiResult.isSuccess &&
                <WalletsComponent assetHolderId={assetHolderId} wallets={getWalletsApiResult.data}/>
              }
            </Box>
          </Box>

          { /* ============================================================================================= */}

          <Box sx={{ mb: verticalSpacing }}>
            <Typography variant={'h3'} sx={{ mb: 1 }}>Transactions</Typography>
            <ActivityStatementComponent assetHolderId={assetHolderId}/>
          </Box>

          <Divider sx={{ mb: 5 }}/>

          { /* ============================================================================================= */}

          <Box>
            <Typography variant={'h5'}>The following tools are available on this page:</Typography>
            <List>
              <ListItem>
                <Typography variant={'body1'}><b>Charity Contributions</b>&nbsp;- Donate your entire balance from both
                  your ZAR and BTC wallets to a selected charity.</Typography>
              </ListItem>
              <ListItem>
                <Typography variant={'body1'}><b>Converting ZAR payout balance to BTC</b>&nbsp;- Schedule a conversion
                  of your entire ZAR wallet balance to your BTC wallet. This tool is intended for use by members who do
                  not have a South African bank account.</Typography>
              </ListItem>
              <ListItem>
                <Typography variant={'body1'}><b>Cash Out Accounts</b>&nbsp;- Add or update a cash out account to your
                  profile, either a South African Bank account or a BTC address.</Typography>
              </ListItem>
              <ListItem>
                <Typography variant={'body1'}><b>Cash Outs</b>&nbsp;- Schedule a cash out to one of the cash out
                  accounts you’ve added to your profile.</Typography>
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ pb: 3, mb: verticalSpacing }}/>

          { /* ============================================================================================= */}

          {getWalletsApiResult.isSuccess && (
            <Box sx={{ mb: verticalSpacing }}>
              {/* <Typography variant={'h3'} sx={{ mb: 1 }}>Charity Contributions</Typography> */}
              <AccordionCharityDisbursementOption
                assetHolderId={assetHolderId}
                assetHolder={getAssetHolderApiResult.data}
                wallets={getWalletsApiResult.data}
                maxCardWidth={maxCardWidth}
              />
              {/* </Box> */}
            </Box>
          )}

          { /* ============================================================================================= */}

          {getWalletsApiResult.isSuccess && (
            <Box sx={{ mb: verticalSpacing }}>
              {/* <Typography variant={'h3'} sx={{ mb: 1 }}>Converting ZAR payout balance to BTC</Typography> */}
              <AccordionExchangeInstructions
                assetHolderId={assetHolderId}
                assetHolder={getAssetHolderApiResult.data}
                wallets={getWalletsApiResult.data}
                verticalSpacing={verticalSpacing}
                maxCardWidth={maxCardWidth}
              />
            </Box>
          )}

          { /* ============================================================================================= */}

          <Box sx={{ mb: verticalSpacing }}>
            {/* <Typography variant={'h3'} sx={{ mb: 1 }}>Converting ZAR payout balance to BTC</Typography> */}
            <AccordionCashOutAccounts
              assetHolderId={assetHolderId}
              assetHolder={getAssetHolderApiResult.data}
              maxCardWidth={maxCardWidth}/>
          </Box>

          { /* ============================================================================================= */}

          {getWalletsApiResult.isSuccess && (

            <Box sx={{ mb: verticalSpacing }}>
              {/* <Box sx={{ maxWidth: maxCardWidth }}> */}
              {/* <Typography variant={'h3'} sx={{ mb: 1 }}>Converting ZAR payout balance to BTC</Typography> */}
              <AccordionCashOuts
                assetHolderId={assetHolderId}
                assetHolder={getAssetHolderApiResult.data}
                wallets={getWalletsApiResult.data}
                verticalSpacing={verticalSpacing}
                maxCardWidth={maxCardWidth}

              />
            </Box>
          )}

          { /* ============================================================================================= */}
          { /* ============================================================================================= */}
          { /* ============================================================================================= */}

          {/* {userSettlementsEnabled && ( */}

          {/*  <> */}
          {/*    <Box sx={{ mb: verticalSpacing }}> */}
          {/*      <Typography variant={'h3'} sx={{ mb: 1 }}>Converting ZAR payout balance to BTC</Typography> */}

          {/*      {getPendingExchangeInstructionsApiResult.isLoading && <LoadingComponent/>} */}
          {/*      {getPendingExchangeInstructionsApiResult.isError && */}
          {/*        <ErrorComponent */}
          {/*          message={RtkQueryHelper.mapResponseError(getPendingExchangeInstructionsApiResult.error)}/>} */}

          {/*      {!getAssetHolderApiResult.data.hasPassedKyc && */}
          {/*        <Box sx={{ my: verticalSpacing, maxWidth: maxCardWidth }}> */}
          {/*          <Alert severity="warning" sx={{ mt: 3 }}> */}
          {/*            <b>Note:</b> Please complete your KYC on the &apos;My Profile&apos; tab in order to schedule a ZAR Payout in BTC request. */}
          {/*          </Alert> */}
          {/*        </Box> */}
          {/*      } */}

          {/*      {getPendingExchangeInstructionsApiResult.isSuccess && */}
          {/*        <ExchangeInstructionsComponent */}
          {/*          assetHolderId={assetHolderId} */}
          {/*          instructions={getPendingExchangeInstructionsApiResult.data} */}
          {/*          maxCardWidth={maxCardWidth} */}
          {/*        /> */}
          {/*      } */}

          {/*      <Box> */}
          {/*        {(getPendingExchangeInstructionsApiResult.isSuccess && getWalletsApiResult.isSuccess) && */}
          {/*          <CreateExchangeInstructionComponent */}
          {/*            assetHolderId={assetHolderId} */}
          {/*            wallets={getWalletsApiResult.data} */}
          {/*            hasPassedKyc={getAssetHolderApiResult.data.hasPassedKyc} */}
          {/*            maxCardWidth={maxCardWidth} */}
          {/*            existingInstructions={getPendingExchangeInstructionsApiResult.data}/> */}
          {/*        } */}
          {/*      </Box> */}

          {/*    </Box> */}

          {/*    <Divider sx={{ mb: 5 }}/> */}
          {/*  </> */}
          {/* )} */}

          { /* ============================================================================================= */}

          {/* <Box sx={{ mb: verticalSpacing }}> */}
          {/*  <Typography variant={'h3'} sx={{ mb: 1 }}>Cash Outs</Typography> */}

          {/*  {getPendingDisbursementInstructions.isLoading && <LoadingComponent/>} */}
          {/*  {getPendingDisbursementInstructions.isError && */}
          {/*    <ErrorComponent message={RtkQueryHelper.mapResponseError(getPendingDisbursementInstructions.error)}/>} */}

          {/*  {!getAssetHolderApiResult.data.hasPassedKyc && */}
          {/*    <Box sx={{ my: verticalSpacing, maxWidth: maxCardWidth }}> */}
          {/*      <Alert severity="warning" sx={{ mt: 3 }}> */}
          {/*        <b>Note:</b> Please complete your KYC on the &apos;My Profile&apos; tab in order to add/update cash out account details or to schedule a */}
          {/*        cash out request. */}
          {/*      </Alert> */}
          {/*    </Box> */}
          {/*  } */}

          {/*  {getPendingDisbursementInstructions.isSuccess && */}
          {/*    <DisbursementInstructionsComponent */}
          {/*      assetHolderId={assetHolderId} */}
          {/*      pendingDisbursementInstructions={getPendingDisbursementInstructions.data} */}
          {/*      maxCardWidth={maxCardWidth} */}
          {/*    /> */}
          {/*  } */}

          {/*  <Box> */}
          {/*    {(getDisbursementFeesApiResult.isSuccess && getDisbursementAccountsApiResult.isSuccess && getWalletsApiResult.isSuccess) && */}
          {/*      <CreateDisbursementInstructionComponent */}
          {/*        assetHolderId={assetHolderId} */}
          {/*        disbursementFees={getDisbursementFeesApiResult.data} */}
          {/*        disbursementAccounts={getDisbursementAccountsApiResult.data} */}
          {/*        wallets={getWalletsApiResult.data} */}
          {/*        hasPassedKyc={getAssetHolderApiResult.data.hasPassedKyc} */}
          {/*        maxCardWidth={maxCardWidth} */}
          {/*      /> */}
          {/*    } */}

          {/*    {(getDisbursementFeesApiResult.isLoading) && <LoadingComponent/>} */}
          {/*    {getDisbursementFeesApiResult.isError && */}
          {/*      <ErrorComponent message={RtkQueryHelper.mapResponseError(getDisbursementFeesApiResult.error)}/>} */}

          {/*    {getDisbursementFeesApiResult.isSuccess && */}
          {/*      <DisbursementFeesComponent disbursementFees={getDisbursementFeesApiResult.data}/> */}
          {/*    } */}
          {/*  </Box> */}

          {/* </Box> */}

          {/* <Divider sx={{ mb: 5 }}/> */}

          { /* ============================================================================================= */}

          {/* <Box sx={{ my: verticalSpacing }}> */}
          {/*  <Typography variant={'h3'} sx={{ mb: 1 }}>Cash Out Accounts</Typography> */}

          {/*  {(getDisbursementAccountsApiResult.isLoading) && <LoadingComponent/>} */}
          {/*  {getDisbursementAccountsApiResult.isError && */}
          {/*    <ErrorComponent message={RtkQueryHelper.mapResponseError(getDisbursementAccountsApiResult.error)}/>} */}

          {/*  {getDisbursementAccountsApiResult.isSuccess && */}
          {/*    <AccountsComponent */}
          {/*      assetHolderId={assetHolderId} */}
          {/*      disbursementAccounts={getDisbursementAccountsApiResult.data} */}
          {/*      hasPassedKyc={getAssetHolderApiResult.data.hasPassedKyc} */}
          {/*      maxCardWidth={maxCardWidth} */}
          {/*      multiAccountView={true} */}
          {/*    /> */}
          {/*  } */}
          {/* </Box> */}
        </>
      }
    </>
  )
}

export default FinanceTabComponent
